var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "el-form-item",
          {
            attrs: {
              label: _vm.$t.__(
                "dashboard.forms.OpportunitySettingForm.select_status_to_display"
              ),
              prop: "status"
            }
          },
          [
            _c(
              "el-select",
              {
                staticClass: "wp-4",
                attrs: { multiple: "", "multiple-limit": 2 },
                model: {
                  value: _vm.form.status,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "status", $$v)
                  },
                  expression: "form.status"
                }
              },
              _vm._l(_vm.statusList, function(status) {
                return _c("el-option", {
                  key: status.value,
                  attrs: { label: status.label, value: status.value }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          {
            attrs: {
              label: _vm.$t.__(
                "dashboard.forms.OpportunitySettingForm.select_pipelines_to_use"
              ),
              prop: "pipeline"
            }
          },
          [
            _c(
              "el-select",
              {
                staticClass: "wp-4",
                attrs: {
                  placeholder: _vm.$t.__(
                    "dashboard.forms.OpportunitySettingForm.all_pipelines"
                  ),
                  multiple: ""
                },
                model: {
                  value: _vm.form.pipeline,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "pipeline", $$v)
                  },
                  expression: "form.pipeline"
                }
              },
              _vm._l(_vm.pipelineList, function(pipeline) {
                return _c("el-option", {
                  key: pipeline.value,
                  attrs: { label: pipeline.label, value: pipeline.value }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "aright mt-5" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.cancel"),
                type: "secondary"
              },
              on: { click: _vm.close }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.save"),
                type: "primary"
              },
              on: { click: _vm.submitForm }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }